import type { Theme } from '@mui/material';

export const useStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chipRoot: {
    maxWidth: '100%',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  chipLabel: {
    display: 'block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    userSelect: 'auto',
  },
});
